import { styled } from '@acko-tech/building-blocks.ui.common';

export const FooterWrapper = styled.div`
    width: 100%;
    height: 65px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #f6f7fb;
    bottom: 0;
    position: fixed;
    margin-right: 0;
    @media screen and (min-width: 780px) {
        width: 360px;
        position: relative;
    }
`;

export const TollFreeNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #737f8b;
`;

export const Number = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 10px;
    line-height: 12px;
    text-align: right;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #343758;
`;
